import Bacon from 'Bacon';
import ga from "analytics";
import ajax from "ajax";
import c from "common";

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {computedAsync} from 'computed-async-mobx';
import cache from 'cache';

export function getBanner(section) {
    const url = section ? "/api/banner/" + section : "/api/banner";
    return ajax.stream({
        url: url,
        type: "GET"
    });
}

export class BannerStore {
    section = null;
    @observable bannerPromise = null;

    bannerData = computedAsync({
        init: null,
        fetch: () => this.bannerPromise,
    });

    @action update = bannerStream => {
        this.bannerPromise = Bacon.constant(bannerStream).flatMap(v => v).toPromise();
    };

    reload = section => {
        if (this.section !== section) {
            this.section = section;
            this.update(getBanner(section));
        }
    };

    // TODO: figure out how to remove this
    initBannerClickTracking($container, bannerType) {
        $container.asEventStream("click", ".banner").map(c.$currentTarget).onValue($target => {
            const $linkTarget = $target.parent("a").attr("href");
            ga.trackBannerClick($target.find(".banner-img").attr("src"), bannerType, $linkTarget ? $linkTarget : "");
        });
    }
}

@inject('bannerStore')
@observer
export class Banner extends Component {
    static propTypes = {
        section: PropTypes.string,
        bannerSrc: PropTypes.string,
        bannerStore: PropTypes.instanceOf(BannerStore),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        this.updateBanner(this.props);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(props) {
        this.updateBanner(props);
    }

    updateBanner({section, bannerSrc}) {
        if (bannerSrc) {
            this.props.bannerStore.update(cache(bannerSrc));
        } else {
            this.props.bannerStore.reload(section);
        }
    }

    render() {
        const {bannerStore: {bannerData: {value}}} = this.props;
        if (!value) {
            return null;
        }

        const {isValid, link, backgroundUrl, description} = value;
        if (!isValid) {
            return <div style={{marginTop: '5rem'}} />;
        }
        if (link) {
            return (
                <div className='banner-container'>
                    <a data-ajax='false' href={link} className='banner-link'>
                        <div className='banner' data-banner-type='banner'>
                            <img src={backgroundUrl} alt={description} className="banner-img"/>
                            {description ? <h2>{description}</h2> : null}
                        </div>
                    </a>
                </div>
            );
        }

        return (
            <div className='banner-container'>
                <div className='banner' data-banner-type='banner'>
                    <img src={backgroundUrl} alt={description} className="banner-img"/>
                    {description ? <h2>{description}</h2> : null}
                </div>
            </div>
        );
    }
}

export default new BannerStore();



// WEBPACK FOOTER //
// ./web/js/background.js